/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as React from 'react';
import { useSelector } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: '#eb0000 !important',
  },
}));
export default function AllocatePaymentTab(props) {
  const classes = useStyles();
  // props
  const { tabValue, handleChangeTabValue } = props;
  const qtrVal = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.qtrVal
  );

  return (
    <>
      <div data-testid="comment-tab" className={`${classes.root} tabs-nocursor`}>
        <AppBar
          position="static"
          sx={{ width: '100%' }}
          style={{ borderBottom: '1px solid #c9c8c5' }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            color="red"
            style={{ color: 'red' }}
          >
            <Tab
              style={{ textTransform: 'capitalize' }}
              value="one"
              label="ROSI"
              tabIndex="0"
            />
            <Tab
              style={{ textTransform: 'capitalize' }}
              value="two"
              label="PQAS"
              tabIndex="1"
              disabled = {!qtrVal}
            />
          </Tabs>
        </AppBar>
      </div>
    </>
  );
}
